// extracted by mini-css-extract-plugin
module.exports = {"action-ico":"bookmark-button_action-ico__541d5","action-btn":"bookmark-button_action-btn__FUnUJ","active":"bookmark-button_active__51due"};